{
  "__localization_test_string": "Ou rive nan kantite maksimòm vizit bay founisè sa a pou {{time_period}}. Ou ka pwochen vizite founisè sa a apati {{start_date}}.",
  "app_name": "Plentiful",
  "app_button_ok": "Ok",
  "app_button_cancel": "Anile",
  "app_button_yes": "Wi",
  "app_button_no": "Okenn",
  "app_button_confirm": "Konfime",
  "app_button_try_again": "Eseye anko",
  "rate_the_app": "Evalye Plentiful",
  "app_textview_somethingwentwrong": "Yon bagay ale mal!\nTanpri, eseye ankò",
  "app_button_logout": "Dekonekte",
  "app_today": "Jodi a",
  "app_dialog_clarify_prompt": "Èske ou sèten?",
  "app_personal_edittext_phone": "Nimewo telefòn",
  "app_personal_edittext_dob": "Dat nesans (si ou vle)",
  "app_personal_edittext_firstname": "Premye non",
  "app_personal_edittext_lastname": "Siyati",
  "app_personal_edittext_zipcode": "Kòd postal",
  "app_pantrykind_food": "Manje gadmanje",
  "app_servicekind_reservations": "Rezèvasyon",
  "app_servicekind_line": "Lign",
  "distribution_schedule": "Orè Distribisyon",
  "service_type_no_digital_options": "Lign Sèlman",
  "service_type_reservation_inline": "Rezèvasyon",
  "service_type_allows_pre_registration": "Pèmèt Pre-Enskripsyon",
  "app_locationnotavailable": "Kote pa disponib",
  "app_generalerror": "Erè",
  "app_dialog_loading": "Loading. Souple tann…",
  "app_dialog_sms_code_title": "Kòd SMS",
  "app_dialog_sms_code_button_send_new_code": "Voye yon nouvo kòd",
  "app_release_id": "Idantifyan lage aplikasyon an",
  "sms_disclaimer": "Frè mesaj ak done ka aplike. Voye STOP pou dezabòne.",
  "fragment_registration_language_textview_title": "Chwazi lang ou prefere a pou kòmanse",
  "fragment_registration_language_button_next": "Apre",
  "fragment_registration_family_textview_title": "Di nou kijan moun lakay ou ye",
  "fragment_registration_family_textview_adults": "Kantite Adilt (18–{{senior_age_threshold_minus_one}})",
  "fragment_registration_family_textview_children": "Kantite Timoun (anba 18 an)",
  "fragment_registration_family_textview_seniors": "Kantite Granmoun Aje ({{senior_age_threshold}}+)",
  "fragment_registration_family_textview_notetitle": "Remak:",
  "fragment_registration_family_textview_notecontent": "Ede nou sèvi w pi byen lè w ban nou detay sou moun k ap viv lakay ou. Tanpri sonje: pa mete tèt ou nan kantite moun k ap viv lakay ou ki nan lis anwo a.",
  "fragment_registration_family_button_back": "Ranfòse",
  "fragment_registration_family_button_next": "Apre",
  "fragment_registration_personal_textview_title": "Byenveni nan Pwofil Plentiful ou a",
  "fragment_registration_personal_button_back": "Ranfòse",
  "fragment_registration_personal_button_finish": "Kaba",
  "fragment_main_tabitem_pantrymap": "Plan",
  "fragment_main_tabitem_pantrylist": "Lis",
  "fragment_main_bottombar_pantries": "Pantris",
  "fragment_main_bottombar_visits": "Vizit",
  "fragment_main_bottombar_messages": "Mesaj",
  "fragment_main_bottombar_profile": "Profil",
  "cell_pantry_short_visit_date": "Ou prale",
  "fragment_pantrydetail_button_changetime": "Chanje tan",
  "fragment_pantrydetail_textview_amenities": "Ekipman",
  "fragment_pantrydetail_textview_conditions": "Kondisyon",
  "fragment_pantrydetail_textview_notes": "Pantry nòt",
  "fragment_pantrydetail_edittext_message": "Mesaj ...",
  "fragment_pantrydetail_button_createreservation": "Pwograme yon vizit",
  "fragment_pantrydetail_button_schedulevisit": "orè vizit",
  "dialog_visittime_textview_nodatesavailable": "Pa gen dat ki disponib",
  "fragment_visitlist_textview_title": "Vizit",
  "fragment_visitlist_textview_zero": "Sa a se kote ou ka jere fwa sèvis k ap vini ou yo. Jwenn yon gadmanje pou pran yon vizit!",
  "fragment_messagethreadlist_textview_title": "Mesaj",
  "fragment_messagethreadlist_textview_zero": "Pa gen mizajou pou kounye a!\nPou abòne pou mizajou yo, ale nan paj detay gadmanje ou pi renmen an epi aktive 'Jwenn Mizajou Nan Gadmanje Sa a' ki nan pati anba paj la.",
  "fragment_profile_textview_title": "Profil",
  "fragment_profile_button_savechanges": "Sove chanjman",
  "fragment_profile_textview_personaldetails": "Detay pèsonèl",
  "fragment_profile_textview_language": "Lang",
  "fragment_profile_textview_notifications": "Notifikasyon",
  "fragment_profile_switch_receivenotifications": "Notifikasyon Push",
  "receive_notifications_helper": "Resevwa alèt sou aparèy ou",
  "fragment_profile_textview_servicedetails": "Detay sèvis yo",
  "fragment_profile_switch_pickupfood": "Mwen gen yon lòt moun ki vin pran manje mwen an",
  "fragment_profile_edittext_pickupname": "Non ak siyati reprezantan pickup",
  "fragment_profile_edittext_pickupphone": "Nimewo Telefòn Reprezantan Ranmasaj la",
  "textview_baby_supplies": "Konbyen timoun ou bezwen founiti pou tibebe (kouchèt, ti sèvyèt, fòmil)",
  "fragment_profile_textview_emergencycontact": "Kontak Ijans",
  "fragment_profile_edittext_emergencyname": "Non ak non kontak ijans",
  "fragment_profile_edittext_emergencyphone": "Telefòn Kontak Ijans",
  "aiq_validation_error_regex_telephone_us": "Nimewo telefòn nan fòma pa kòrèk",
  "fragment_profile_textview_changepersonalinfo": "Enfòmasyon sa a ka mete ajou nan nenpòt ki gadmanje manje Plentiful.",
  "fragment_profile_edittext_feedback": "Feedback ...",
  "fragment_profile_toast_feedbacksent": "Feedback voye",
  "baby_supplies": "Pwodwi pou ti bebe",
  "household_size": "Gwosè Kay la",
  "food_pickup": "Ranmase manje",
  "emergency_contact": "Kontak Ijans",
  "dialog_app_update_title": "Aktyalizasyon disponib",
  "dialog_app_update_message": "Next vèsyon an app a ki disponib nan magazen an Jwe Google!",
  "dialog_app_update_button_openplaystore": "Louvri Jwe Store",
  "app_invalid_error": "Envalid",
  "no_pantries_available": "Pa jwenn okenn rezilta. Eseye rechèch ou a avèk yon lòt non gadmanje oubyen efase bwat rechèch la epi deplase oubyen rale sou kat jeyografik la pou w eksplore zòn ki gen gadmanje Plentiful.",
  "visit_served": "chandi",
  "visit_not_served": "pa sèvi",
  "visit_no_show": "ou pa t montre",
  "visit_group": "Ou nan Gwoup {{group_number}}, Vini non {{time}}",
  "visit_pre_registered": "Ou pre-anrejistre, Antre nan liy ki ant {{from_time}} - {{end_time}}",
  "pick_visit_time": "Chwazi tan vizite",
  "received_service_on": "Ou te vizite sou",
  "service_starts_at": "Sèvis kòmanse nan",
  "cancel_visit": "Anile vizit",
  "confirm_cancel_visit": "Èske ou sèten ou vle anile vizit ou a?",
  "yes_cancel": "Wi, anile",
  "send": "Voye",
  "reservations_available": "Jwenn Mizajou nan Gadmanje sa a",
  "report_location_issue": "Rapòte yon pwoblèm ak kote sa a",
  "feeding_america_network_member": "Pati nan rezo Feeding America",
  "feeding_america_find_food_link": "Vizite sit entènèt bank manje a",
  "registration_intro": "Byenveni nan Plentiful! Nou la pou ede w jwenn gadmanje tou pre w.",
  "app_personal_edittext_enter_phone": "Antre nimewo telefòn ou",
  "code_sent_to": "Yo te voye yon kòd login SMS",
  "account_created": "Kont kreye",
  "get_started": "Ann kòmanse!",
  "additional_details": "Enfòmasyon Siplemantè",
  "your_qr_code": "PLENTI-PASS OU",
  "id_number": "Nimewo ID",
  "personal_details_extra": "Enfòmasyon pèsonèl ak preferans",
  "settings": "Anbans",
  "settings_extra": "Lang ak Notifikasyon Anviwònman",
  "not_verified": "Pa verifye ankò",
  "must_be_reverified_by": "Yo dwe reverifye pa",
  "last_verified_on": "Dènye fwa verifye sou",
  "at": "a",
  "no_visit_options_available": "Pa gen okenn opsyon vizit ki disponib pou ou nan moman sa a. Tanpri tcheke kondisyon gadmanje yo oswa kontakte gadmanje a.",
  "need_help": "Bezwen èd?",
  "email": "Kouma",
  "terms_conditions": "Akò Itilizatè Fen",
  "privacy_policy": "Règleman sou vi prive",
  "updates": "Dènye",
  "family_details": "Detay sou Kay la",
  "welcome_to_plentiful": "Byenveni nan Plentiful!",
  "enter_email_phone": "Lè w enskri, sa pèmèt ou fè rezèvasyon epi resevwa dènye nouvèl sou gadmanje ou vizite yo.\nSi ou te enskri nan yon gadmanje, sèvi ak menm nimewo telefòn sa a oswa imèl la. \nBezwen èd? Kontakte nou nan support@plentiful.org",
  "email_or_phone": "Nimewo mobil oswa adrès imel",
  "email_address": "Adrès Imèl",
  "enter_email": "Antre nan imèl ou",
  "address": "Adrese",
  "email_invalid": "Adrès imèl la pa valab",
  "no_sms_enabled_phone": "Nimewo telefòn pa ka resevwa mesaj tèks",
  "verification_email_sent": "Imèl verifikasyon voye!",
  "check_verification_email": "Tcheke imel ou epi klike sou bouton anndan an pou verifye kont ou",
  "email_verification_sent": "Nou te voye yon imèl ba ou. Tanpri klike sou bouton ki nan imel la pou verifye adrès imel ou.",
  "email_address_purpose": "pou resevwa rapèl vizit ak mizajou enpòtan nan men Plentiful",
  "sign_up": "Enskri",
  "sign_in": "Siyen an",
  "continue": "Kontinye",
  "create_password": "Kreye modpas",
  "enter_password": "Tanpri antre modpas ou pou siyen",
  "password_info_box": "Si ou bliye modpas ou oswa ou te anrejistre nan yon gadmanje san yo pa mete yon modpas, tanpri itilize opsyon ki anba yo pou konekte avèk yon maji oswa pou reset modpas ou.",
  "reset_password": "Reyajiste modpas",
  "password": "Paròl",
  "eight_characters": "Omwen 8 karaktè",
  "one_special_character": "Omwen 1 karaktè espesyal",
  "one_number": "Omwen yon nimewo",
  "submit": "Soumèt",
  "send_magic_link": "Voye lyen majik",
  "magic_link_sent": "Yon Magic Link ap vini nan imèl ou.",
  "confirm_magic_link_login": "Konfime lyen majik Login",
  "sign_in_another_way": "Siyen nan yon lòt fason",
  "enter_phone": "Tanpri antre nimewo telefòn ou",
  "skip": "Sote",
  "optional": "volontè",
  "enter_activation_code": "Tanpri antre kòd login ou a",
  "activation_code": "Kòd konekte",
  "accept_eula": "Mwen te li epi mwen dakò ak kondisyon ki nan itilize ak vi prive",
  "email_verified": "Imèl verifye",
  "email_verified_details": "Adrès imèl ou an kounye a verifye.",
  "do_not_ask_again": "Pa mande ankò.",
  "email_in_use": "Nou deja gen yon kont ki asosye avèk imèl sa a. Tanpri itilize yon imèl diferan",
  "reset_password_text": "Tanpri antre imèl ou pou retabli modpas ou",
  "reset_password_sent": "Reyajiste modpas imèl voye!",
  "reset_password_sent_text": "Si nou gen yon kont sou dosye pou {{email}}, nou te voye yon lyen Reyajiste modpas ou,",
  "dob_required": "Dat nesans",
  "please_verify": "Tanpri verifye telefòn oswa imèl nan pwofil ou",
  "open_profile": "Louvri pwofil",
  "send_another_verification_email": "Voye yon lòt imèl verifikasyon",
  "need_to_change_email": "Si ou bezwen chanje adrès imel ou, tanpri kontakte support@plentifulapp.com.",
  "need_to_change_email_or_phone": "Si ou bezwen chanje adrès imel ou oswa nimewo telefòn ou, tanpri kontakte support@plentifulapp.com.",
  "need_to_change_phone": "Si ou bezwen chanje nimewo telefòn ou, tanpri kontakte support@plentifulapp.com oswa ale nan yon gadmanje.",
  "email_subscription": "Imèl abònman",
  "email_subscribed": "Imèl enskri",
  "email_unsubscribed": "Imèl unsubscribed",
  "email_subscribed_text": "Ou gen kounye a enskri {{email}} nan imèl Plentiful",
  "email_unsubscribed_text": "Ou gen kounye a unsubscribed {{email}} soti nan imèl Plentiful",
  "here_to_subscribe": "Klike la a pou abònman nan Imèl Plentiful",
  "here_to_unsubscribe": "Klike la a pou koupe abònman nan imèl Plentiful",
  "unsubscribe": "Koupe abònman",
  "subscribe": "Abònman",
  "open_profile_text": "Klike la a pou yo ale nan pwofil ou",
  "sign_in_text": "Klike la a pou siyen",
  "phone_assigned": "Nimewo telefòn sa a deja itilize. Antre nan yon lòt nimewo telefòn oswa ale retounen lakay yo epi siyen nan ak nimewo telefòn sa a pito.",
  "email_subscribe": "Mizajou Imèl",
  "email_subscribe_helper": "Imèl nan men gadmanje ou vizite ak Plentiful",
  "message_preferences": "Preferans Mesaj",
  "message_preferences_description": "Ki jan ou ta renmen resevwa rapèl vizit ak mizajou?",
  "message_method_option_0": "Imèl ak Notifikasyon App",
  "message_method_option_1": "Prefere SMS",
  "message_method_helper_add_phone": "Ajoute nimewo telefòn ou pou resevwa mesaj SMS",
  "message_method_helper_sms_opt_in": "Voye 'START' bay PANTRY (726-879) pou re-enskri nan SMS",
  "message_method_helper_add_email": "Ajoute imèl ou pou resevwa mesaj imèl",
  "message_method_helper_email_unsub": "Ou te dezabòne nan imèl yo. Mete ajou preferans imèl ou pou resevwa yo.",
  "message_method_helper_add_push": "Telechaje aplikasyon mobil la pou resevwa notifikasyon push",
  "message_method_helper_enable_push": "Aktive notifikasyon nan paramèt aparèy ou a pou resevwa notifikasyon push",
  "password_error": "Move modpas. Eseye ankò, reset modpas ou, oswa siyen nan yon lòt fason",
  "action_required": "Aksyon obligatwa",
  "otp_error": "Kòd pa ta ka verifye",
  "show_more": "Montre plis",
  "pre_registration": "Enskripsyon",
  "show_less": "Montre mwens",
  "reschedule": "Rapòte",
  "view_pantry": "Gade Detay Gadmanje",
  "next_service_on": "Next sèvis sou",
  "add_birthday": "Ajoute dat nesans ou pou debloke Plenti-Pass ou a",
  "birthday_required": "Ou ka itilize pas sa a pou anrejistreman rapid e fasil nan gadmanje yo.",
  "missed_reservation_on": "Ou rate rezèvasyon ou sou",
  "delete_account": "Efase kont",
  "delete_explain": "Èske ou sèten ou vle efase kont ou a? Sa a pral anile tout vizit gadmanje kap vini yo epi efase kont ou. W ap bezwen anrejistre ankò pou itilize Plentiful.",
  "yes_delete": "Wi, efase",
  "no_cancel": "Non, anile",
  "select_visit_reschedule": "Chwazi vizit la ou vle pran yon lòt randevou",
  "select_visit_cancel": "Chwazi vizit la ou vle anile",
  "search_pantries": "Rezilta rechèch",
  "please_sign_in_or_up": "Ou pral bezwen yon kont abondan pou kontinye. Plentiful se konplètman gratis yo sèvi ak.",
  "sign_in_or_up": "Log in oswa enskri pou kontinye",
  "country_of_birth_option_AF": "Afganistan",
  "country_of_birth_option_AX": "Zile Åland",
  "country_of_birth_option_AL": "Albani",
  "country_of_birth_option_DZ": "Aljeri",
  "country_of_birth_option_AS": "Samoa Ameriken",
  "country_of_birth_option_AD": "Andor",
  "country_of_birth_option_AO": "Angola",
  "country_of_birth_option_AI": "Anguilla",
  "country_of_birth_option_AQ": "Antatik",
  "country_of_birth_option_AG": "Antigwa ak Barbuda",
  "country_of_birth_option_AR": "Ajantin",
  "country_of_birth_option_AM": "Ameni",
  "country_of_birth_option_AW": "Aruba",
  "country_of_birth_option_AU": "Lostrali",
  "country_of_birth_option_AT": "Austrii",
  "country_of_birth_option_AZ": "Azerbaydjan",
  "country_of_birth_option_BS": "Bahamas",
  "country_of_birth_option_BH": "Bahrain",
  "country_of_birth_option_BD": "Bangladèch",
  "country_of_birth_option_BB": "Barbad",
  "country_of_birth_option_BY": "Breeta",
  "country_of_birth_option_BE": "Nejeji",
  "country_of_birth_option_BZ": "Mezi",
  "country_of_birth_option_BJ": "Benen",
  "country_of_birth_option_BM": "Bermuda",
  "country_of_birth_option_BT": "Boutè",
  "country_of_birth_option_BO": "Bolivi",
  "country_of_birth_option_BA": "Bosni ak Erzegovin",
  "country_of_birth_option_BW": "Botswana",
  "country_of_birth_option_BV": "Bouvet Island",
  "country_of_birth_option_BR": "Brezil",
  "country_of_birth_option_IO": "Britanik Endyen Oseyan Teritwa",
  "country_of_birth_option_BN": "Brunei Darussalam",
  "country_of_birth_option_BG": "Bilgari",
  "country_of_birth_option_BF": "Burkina Faso",
  "country_of_birth_option_BI": "Boudonati",
  "country_of_birth_option_KH": "Kanbòdj",
  "country_of_birth_option_CM": "Kèpion",
  "country_of_birth_option_CA": "Kanada",
  "country_of_birth_option_CV": "Cape Verde",
  "country_of_birth_option_KY": "Zile Kayiman",
  "country_of_birth_option_CF": "Repiblik Afrik Santral",
  "country_of_birth_option_TD": "Chad",
  "country_of_birth_option_CL": "Kretyen",
  "country_of_birth_option_CN": "Pòslèn",
  "country_of_birth_option_CX": "Nwèl zile",
  "country_of_birth_option_CC": "Zile Cocos (Keeling).",
  "country_of_birth_option_CO": "Kolonbi",
  "country_of_birth_option_KM": "Komò",
  "country_of_birth_option_CG": "Plase Kongo",
  "country_of_birth_option_CD": "Kongo, Repiblik Demokratik la nan la",
  "country_of_birth_option_CK": "Zile Cook",
  "country_of_birth_option_CR": "Kosta Rika",
  "country_of_birth_option_CI": "Cote D 'Ivoire",
  "country_of_birth_option_HR": "Kwoasi",
  "country_of_birth_option_CU": "Kib",
  "country_of_birth_option_CY": "Lil Chip",
  "country_of_birth_option_CZ": "Repiblik Tchekoslovaki",
  "country_of_birth_option_DK": "Denmark",
  "country_of_birth_option_DJ": "Djibouti",
  "country_of_birth_option_DM": "Dominik",
  "country_of_birth_option_DO": "Repiblik Dominikèn",
  "country_of_birth_option_EC": "Ekwatè",
  "country_of_birth_option_EG": "Nan peyi a",
  "country_of_birth_option_SV": "Salvador",
  "country_of_birth_option_GQ": "Gine ekwateryal",
  "country_of_birth_option_ER": "Erityè",
  "country_of_birth_option_EE": "Estoni",
  "country_of_birth_option_ET": "Peyi Letiopi",
  "country_of_birth_option_FK": "Zile Falkland (Malvinas)",
  "country_of_birth_option_FO": "Zile Feroe",
  "country_of_birth_option_FJ": "Fidji",
  "country_of_birth_option_FI": "Fonland",
  "country_of_birth_option_FR": "Lafrans",
  "country_of_birth_option_GF": "Franse gwiyane",
  "country_of_birth_option_PF": "Polynesia franse",
  "country_of_birth_option_TF": "Teritwa franse Sid",
  "country_of_birth_option_GA": "Gabon",
  "country_of_birth_option_GM": "Gambi",
  "country_of_birth_option_GE": "Georgia",
  "country_of_birth_option_DE": "Konn lekòl",
  "country_of_birth_option_GH": "Ghan",
  "country_of_birth_option_GI": "Gibraltar",
  "country_of_birth_option_GR": "Grès",
  "country_of_birth_option_GL": "Greenland",
  "country_of_birth_option_GD": "Grenada",
  "country_of_birth_option_GP": "Gwadloup",
  "country_of_birth_option_GU": "Gerye",
  "country_of_birth_option_GT": "Gwatemala",
  "country_of_birth_option_GG": "Guernsey",
  "country_of_birth_option_GN": "Gine",
  "country_of_birth_option_GW": "Gine-Bissau",
  "country_of_birth_option_GY": "Gadzon",
  "country_of_birth_option_HT": "Anyiti",
  "country_of_birth_option_HM": "Tande Island ak McDonald Islands",
  "country_of_birth_option_VA": "Sentespri wè (Vatikan Eta Eta a)",
  "country_of_birth_option_HN": "Ondiras",
  "country_of_birth_option_HK": "Hong Kong",
  "country_of_birth_option_HU": "Ongri",
  "country_of_birth_option_IS": "Chwa",
  "country_of_birth_option_IN": "Las nou",
  "country_of_birth_option_ID": "Endasyonezi",
  "country_of_birth_option_IR": "Iran, Repiblik Islamik nan",
  "country_of_birth_option_IQ": "Irak",
  "country_of_birth_option_IE": "Iland",
  "country_of_birth_option_IM": "Isla de Man",
  "country_of_birth_option_IL": "Pèp Izrayèl",
  "country_of_birth_option_IT": "Italil",
  "country_of_birth_option_JM": "Jamayik",
  "country_of_birth_option_JP": "Japon",
  "country_of_birth_option_JE": "Jersey",
  "country_of_birth_option_JO": "Larivyè Jordan",
  "country_of_birth_option_KZ": "Kazakhstan",
  "country_of_birth_option_KE": "Kenya",
  "country_of_birth_option_KI": "Kiribati",
  "country_of_birth_option_KP": "Kore, Demokratik Moun 's Repiblik la",
  "country_of_birth_option_KR": "Kore di, Repiblik la",
  "country_of_birth_option_KW": "Kowet",
  "country_of_birth_option_KG": "Kyrgyzstan",
  "country_of_birth_option_LA": "Lao Moun 's Demokratik Repiblik",
  "country_of_birth_option_LV": "Letoni",
  "country_of_birth_option_LB": "Liban",
  "country_of_birth_option_LS": "Lesotho",
  "country_of_birth_option_LR": "Libè",
  "country_of_birth_option_LY": "Libyan Arab Jamahiriya",
  "country_of_birth_option_LI": "Liechtenstein",
  "country_of_birth_option_LT": "Lityani",
  "country_of_birth_option_LU": "Liksanbou",
  "country_of_birth_option_MO": "Makao",
  "country_of_birth_option_MK": "Masedwan, ansyen Yougoslav Repiblik la",
  "country_of_birth_option_MG": "Madagascar",
  "country_of_birth_option_MW": "Malawi",
  "country_of_birth_option_MY": "Malezi",
  "country_of_birth_option_MV": "Malveyan",
  "country_of_birth_option_ML": "Mali",
  "country_of_birth_option_MT": "Malta",
  "country_of_birth_option_MH": "Zile Marshall",
  "country_of_birth_option_MQ": "Matinik",
  "country_of_birth_option_MR": "Moritani",
  "country_of_birth_option_MU": "Muritius",
  "country_of_birth_option_YT": "Mayotte",
  "country_of_birth_option_MX": "Meksik",
  "country_of_birth_option_FM": "Mikwonezi, Federated Etazini nan",
  "country_of_birth_option_MD": "Moldavi, Repiblik la",
  "country_of_birth_option_MC": "Monako",
  "country_of_birth_option_MN": "Mongoli",
  "country_of_birth_option_MS": "Montserrat",
  "country_of_birth_option_MA": "Maròk",
  "country_of_birth_option_MZ": "Mozanbik",
  "country_of_birth_option_MM": "Myanma",
  "country_of_birth_option_NA": "Namibi",
  "country_of_birth_option_NR": "Nauru",
  "country_of_birth_option_NP": "Nepal",
  "country_of_birth_option_NL": "Netherlands",
  "country_of_birth_option_AN": "Netherlands Zantiy",
  "country_of_birth_option_NC": "Nouvo Caledonia",
  "country_of_birth_option_NZ": "Nouvèl Zelann",
  "country_of_birth_option_NI": "Nikaragwa",
  "country_of_birth_option_NE": "Nijè",
  "country_of_birth_option_NG": "Nasyongi",
  "country_of_birth_option_NU": "Niue",
  "country_of_birth_option_NF": "Norfolk Island",
  "country_of_birth_option_MP": "Northern Mariana Islands",
  "country_of_birth_option_NO": "Nò nan",
  "country_of_birth_option_OM": "OLAN",
  "country_of_birth_option_PK": "Pakistan",
  "country_of_birth_option_PW": "Pale",
  "country_of_birth_option_PS": "Teritwa Palestinyen, okipe",
  "country_of_birth_option_PA": "Panama",
  "country_of_birth_option_PG": "Papua New Guinea",
  "country_of_birth_option_PY": "Rekreawe",
  "country_of_birth_option_PE": "Perou",
  "country_of_birth_option_PH": "Silifties",
  "country_of_birth_option_PN": "Pitcairn",
  "country_of_birth_option_PL": "Soupland",
  "country_of_birth_option_PT": "Pòtigal",
  "country_of_birth_option_PR": "Pòtoriko",
  "country_of_birth_option_QA": "Krèf",
  "country_of_birth_option_RE": "Reinyon",
  "country_of_birth_option_RO": "Ròch d'",
  "country_of_birth_option_RU": "Poutèt",
  "country_of_birth_option_RW": "Rwanda",
  "country_of_birth_option_SH": "Sen Helena",
  "country_of_birth_option_KN": "Saint Kitts ak Nevi",
  "country_of_birth_option_LC": "Sent Lisi",
  "country_of_birth_option_PM": "Saint Pierre ak Miquelon",
  "country_of_birth_option_VC": "Saint Vincent ak Grenadines yo",
  "country_of_birth_option_WS": "Parèy",
  "country_of_birth_option_SM": "San Marino",
  "country_of_birth_option_ST": "Sao Tome ak Prinsip",
  "country_of_birth_option_SA": "Arabi Saoudit",
  "country_of_birth_option_SN": "Senegal",
  "country_of_birth_option_CS": "Sèbi ak Montenegwo",
  "country_of_birth_option_SC": "Sesel",
  "country_of_birth_option_SL": "Syera Leòn",
  "country_of_birth_option_SG": "Singapore",
  "country_of_birth_option_SK": "Slovaki",
  "country_of_birth_option_SI": "Sloveni",
  "country_of_birth_option_SB": "Salomon Islands",
  "country_of_birth_option_SO": "Somali",
  "country_of_birth_option_ZA": "Afrik di Sid",
  "country_of_birth_option_GS": "South Georgia ak Sandwich Sid Islands yo",
  "country_of_birth_option_ES": "Escou",
  "country_of_birth_option_LK": "Sri Lanka",
  "country_of_birth_option_SD": "Suan",
  "country_of_birth_option_SR": "Sirinam",
  "country_of_birth_option_SJ": "Svalbard ak Jan Mayen",
  "country_of_birth_option_SZ": "Swaziland",
  "country_of_birth_option_SE": "Syèd",
  "country_of_birth_option_CH": "Swis",
  "country_of_birth_option_SY": "Repiblik Arab moun lavil Aram",
  "country_of_birth_option_TW": "Taiwan, pwovens nan Lachin",
  "country_of_birth_option_TJ": "Tadjikistan",
  "country_of_birth_option_TZ": "Tanzani, Etazini Repiblik",
  "country_of_birth_option_TH": "Thailand",
  "country_of_birth_option_TL": "Timor-Leste",
  "country_of_birth_option_TG": "Togo",
  "country_of_birth_option_TK": "Tokelau",
  "country_of_birth_option_TO": "Tonga",
  "country_of_birth_option_TT": "Trinidad ak Tobago",
  "country_of_birth_option_TN": "Trisesi",
  "country_of_birth_option_TR": "Kodenn",
  "country_of_birth_option_TM": "Tirkmenistan",
  "country_of_birth_option_TC": "Il Tirk ak Caicos Islands",
  "country_of_birth_option_TV": "Touval",
  "country_of_birth_option_UG": "Uganda",
  "country_of_birth_option_UA": "Ikrèn",
  "country_of_birth_option_AE": "Emira Arab Ini",
  "country_of_birth_option_GB": "Wayòm Ini",
  "country_of_birth_option_US": "Etazini",
  "country_of_birth_option_UM": "Zile minè Etazini minè",
  "country_of_birth_option_UY": "Irigwe",
  "country_of_birth_option_UZ": "Ouzbekistan",
  "country_of_birth_option_VU": "Vanwatou",
  "country_of_birth_option_VE": "Venezyela",
  "country_of_birth_option_VN": "Vyetnam",
  "country_of_birth_option_VG": "Zile Vyèj, Britanik",
  "country_of_birth_option_VI": "Zile Vyèj, Etazini.",
  "country_of_birth_option_WF": "Wallis ak Futuna",
  "country_of_birth_option_EH": "Sahara Lwès",
  "country_of_birth_option_YE": "Yèz",
  "country_of_birth_option_ZM": "Zanbi",
  "country_of_birth_option_ZW": "Zimbabwe",
  "gender_option_female": "Femèl",
  "gender_option_male": "Mal",
  "gender_option_nonconf": "Sèks ki pa konfòme",
  "relationship_status_option_single": "Sèl",
  "relationship_status_option_domestic_partner": "Patnè domestik",
  "relationship_status_option_common_law": "Komen",
  "relationship_status_option_emancipated_minor": "Emansipe minè",
  "relationship_status_option_married": "Marye",
  "relationship_status_option_divorced": "Divòse",
  "relationship_status_option_separated": "Separe",
  "relationship_status_option_widowed": "Vèf",
  "housing_option_own": "Posede",
  "housing_option_room_in_apartment": "Sal nan apatman an",
  "housing_option_friends_or_family": "Zanmi oswa fanmi",
  "housing_option_regular_rent": "Regilye lwaye",
  "housing_option_subsidized_rent": "Lwaye sibvansyone",
  "housing_option_shelter": "Abri",
  "housing_option_homeless": "San zabri",
  "employment_option_full_time": "A plen tan",
  "employment_option_part_time": "A tan pasyèl",
  "employment_option_unemployed": "San travay",
  "education_option_no_high_school": "Pa gen lekòl segondè",
  "education_option_high_school_diploma": "Lekòl Segondè Diplòm",
  "education_option_ged": "Ged",
  "education_option_associate_or_bachelo": "Associate oswa Bachelier degre",
  "education_option_post_graduate": "Post-gradye Etid",
  "ethnicity_option_two_or_more_races": "De oswa plis ras",
  "ethnicity_option_black": "Nwa (ki pa Peye-Panyòl)",
  "ethnicity_option_white": "Blan (ki pa Peye-Panyòl)",
  "ethnicity_option_hispanic_or_latino": "Panyòl oswa Latino",
  "ethnicity_option_asian_or_pacific": "Azyatik oswa Pasifik zile",
  "ethnicity_option_american_indian_or_alaskan": "Ameriken Endyen oswa Alaska",
  "ethnicity_option_other": "Lòt",
  "snap_benefits": "Pwogram Asistans Nitrisyon Siplemantè",
  "wic_benefits": "Pwogram Nitrisyon Siplemantè pou Fanm, Timoun Piti, ak Timoun",
  "tanf_benefits": "Asistans Tanporè pou fanmi ki nan nesesite yo",
  "medicaid_benefits": "Asirans sante piblik pou moun ki gen revni ki ba",
  "ssi_benefits": "Pwogram Revni Sekirite Siplemantè",
  "free_reduced_meals": "Gratis oswa redwi pwogram repa",
  "tefap_form": "Sètifikasyon Tefap",
  "tefap_form_expired": "Atestasyon TEFAP ou ekspire sou",
  "tefap_form_usda_title": "USDA Deklarasyon non diskriminasyon",
  "tefap_form_usda_subheader": "Tanpri fè konnen sa ki annapre yo",
  "tefap_form_usda_body": "<p>In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating in or administering USDA programs are prohibited from discriminating based on race, color, national origin, religion, sex, disability, age, marital status, family/parental status, income derived from a public assistance program, political beliefs, or reprisal or retaliation for prior civil rights activity, in any program or activity conducted or funded by USDA (not all bases apply to all programs). Remedies and complaint filing deadlines vary by program or incident.</p><p>Persons with disabilities who require alternative means of communication for program information (e.g., Braille, large print, audiotape, American Sign Language, etc.) should contact the State or local Agency that administers the program or contact USDA through the Telecommunications Relay Service at 711 (voice and TTY). Additionally, program information may be made available in languages other than English.</p><p>To file a program discrimination complaint, complete the USDA Program Discrimination Complaint Form, AD-3027, found online at <a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">How to File a Program Discrimination Complaint</a> and at any USDA office or write a letter addressed to USDA and provide in the letter all of the information requested in the form. To request a copy of the complaint form, call (866) 632-9992. Submit your completed form or letter to USDA by:</p><p>(1) mail: U.S. Department of Agriculture, Office of the Assistant Secretary for Civil Rights, 1400 Independence Avenue, SW, Mail Stop 9410, Washington, D.C. 20250-9410;</p><p>(2) fax: (202) 690-7442; or</p><p>(3) email: <a href=\"mailto:program.intake@usda.gov\">program.intake@usda.gov</a>.</p><p>USDA is an equal opportunity provider, employer, and lender.</p>",
  "app_button_next": "Apre",
  "app_button_back": "Ranfòse",
  "app_button_submit": "Soumèt",
  "app_button_close": "Tou pre",
  "app_button_done": "Fini",
  "form_required": "Obligatwa *",
  "benefits": "Pwogram Benefis",
  "benefits_extra": "Detay sou Pwogram Benefis",
  "help_and_support": "Nou la pou ede",
  "help_and_support_extra": "FAQ ak Enfòmasyon sou Kontakte",
  "frequently_asked_questions": "Kesyon yo poze souvan",
  "contact_support": "Kontakte anpil sipò",
  "optional_details": "Detay si ou vle",
  "address_street_1": "Adrese",
  "address_street_2": "Byen",
  "city": "Lavil",
  "state": "Deklare",
  "zipcode": "Kòd postal",
  "additional_optional_details": "Lòt detay",
  "gender": "Defans",
  "relationship_status": "Sitiyasyon relasyon",
  "ethnicity": "Etnisite",
  "country_of_birth": "Peyi kote ou fèt",
  "employment": "Anplwaman",
  "highest_education_obtained": "Edikasyon",
  "food_preferences": "Preferans manje",
  "housing_details": "Lojman detay",
  "housing_status": "Estati Lojman",
  "special_circumstances": "Sikonstans espesyal",
  "needs_assistance": "Mwen bezwen asistans nan Pantries",
  "dont_need_assistance": "Mwen pa bezwen asistans nan Pantries",
  "aiq_validation_error_min_adult_family_members": "Manm Adilt nan Kay la dwe pi gran pase 0",
  "aiq_validation_error_max_adult_family_members": "Manm Adilt nan Kay la pa ka gen plis pase 10",
  "aiq_validation_error_min_child_family_members": "Manm Kay Timoun yo dwe pi gran pase 0",
  "aiq_validation_error_max_child_family_members": "Manm Timoun nan Kay la pa ka gen plis pase 10",
  "aiq_validation_error_min_senior_family_members": "Manm Granmoun nan Kay la dwe plis pase 0",
  "aiq_validation_error_max_senior_family_members": "Manm Granmoun nan Kay la pa ka gen plis pase 10",
  "aiq_validation_error_required_emergency_contact": "Enfòmasyon pou Kontak Ijans obligatwa",
  "aiq_validation_error_required_pick_up_name": "Ranmase non reprezantan enfòmasyon yo obligatwa",
  "aiq_validation_error_required_birth_date": "Enfòmasyon Dat Nesans obligatwa",
  "aiq_validation_error_regex_zip_code": "Kòd postal dwe nimerik",
  "aiq_validation_error_required_first_name": "Premye Non obligatwa",
  "aiq_validation_error_required_last_name": "Siyati obligatwa",
  "aiq_validation_error_min_baby_supplies": "Pwovizyon pou ti bebe yo dwe pi gran pase 0",
  "aiq_validation_error_max_baby_supplies": "Pwovizyon pou ti bebe pa ka pi gran pase 10",
  "dietary_preferences_option_lactose": "Entolerans laktoz",
  "dietary_preferences_option_gluten": "Gluten entolerans",
  "dietary_preferences_option_kosher": "Kosher",
  "dietary_preferences_option_halal": "Alal",
  "dietary_preferences_option_dairy_free": "Dairy gratis",
  "dietary_preferences_option_vegetarian": "Vejit",
  "dietary_preferences_option_vegan": "Venense",
  "dietary_preferences_option_fodmap": "Fodmap",
  "dietary_preferences_option_nut_allergy": "Tree nwa ak alèji pistach",
  "dietary_preferences_option_fish_allergy": "Pwason ak alèji klere",
  "dietary_preferences_option_none": "Pa gen preferans",
  "tefap_additional_info_requested": "Lòt enfòmasyon yo mande a",
  "tefap_zipcode_correct": "Èske kòd postal ou kòrèk?",
  "tefap_address_correct": "Èske adrès ou kòrèk?",
  "tefap_participate_in_programs": "Nenpòt moun ki nan kay ou patisipe nan nenpòt nan pwogram sa yo?",
  "tefap_check_all_that_apply": "Tanpri tcheke tout sa ki aplike, si pa gen okenn, klike sou pwochen pou plis opsyon.",
  "tefap_household_numbers_correct": "Èske kantite moun ki nan kay ou kòrèk?",
  "tefap_household_dont_include_yourself": "Tanpri pa mete tèt ou sou ekran sa a. TEFAP sèlman egzije kantite total fanmi w, men Plentiful ap montre enfòmasyon ou te bay anvan an.",
  "tefap_income_at_or_below_question": "Se revni ou nan oswa anba a",
  "tefap_for_household_size": "pou kay ou nan",
  "tefap_retake_attestation": "Ou vle repran atestasyon an?",
  "tefap_attestation_completed": "Ou te konplete avèk siksè Fòm Atestasyon Tefap la.",
  "tefap_thank_you": "Mèsi!",
  "tefap_is_recorded": "Atestasyon tefap ou te anrejistre. Ou ka repran li nan pwofil ou.",
  "tefap_sign_below": "Non ou (si ou vle)",
  "tefap_legal_signing": "Lè ou siyen anba a, mwen deklare ke revni m 'ki soti nan tout sous pa depase revni an ki nan lis pi wo a pou kay ki gen menm kantite moun kòm kay mwen an oswa ki kay mwen patisipe nan pwogram nan (yo) ke mwen te tcheke sou fòm sa a. Mwen konprann ke dosye sa yo yo ap fèt nan konfyans nan sit distribisyon sa a, men yo ka lage nan Biwo Eta New York nan Sèvis Jeneral oswa Depatman Etazini nan Agrikilti pou revizyon sou demann yo.",
  "tefap_retake": "Reprann",
  "program_complete_now": "Ranpli kounye a",
  "program_complete_later": "Ranpli pita",
  "reservation_confirmed": "Vizit Konfime",
  "tefap_reservation_confirmed": "Vizit ou konfime!",
  "pre_registration_confirmed": "Vizit Konfime",
  "your_upcoming_reservation": "Vizit ou kap vini an",
  "your_upcoming_pre_registration": "Vizit ou kap vini an",
  "tefap_attestation_needed": "Pantry sa a ap mande atestasyon ou.",
  "tefap_attestation_complete_now": "Ranpli li kounye a epi ekonomize tan nan pwochen vizvye vizvye ou.",
  "tefap_description": "Atravè Pwogram Asistans Manje Ijans (TEFAP), USDA bay sipò manje bay kominote lokal ou a, fè li disponib pou ou atravè ajans kominotè tankou kwizin soup ak gadmanje manje.",
  "tefap_what_is_tefap": "Ki sa ki TEFAP?",
  "tefap_confirm_share_with_pantry": "Tanpri konfime ou vle pataje enfòmasyon sa yo ak sa a gadmanje.",
  "tefap_thanks_for_sharing": "Mèsi pou bay enfòmasyon an plis mande pa gadmanje a!",
  "tefap_continue_make_reservation": "Kontinye pwograme yon vizit",
  "tefap_pantry_is_requesting": "Pantry sa a ap mande ou",
  "tefap_missing_information": "Manke enfòmasyon",
  "tefap_pantry_will_ask": "Klike sou 'Next' pou ajoute enfòmasyon sa a kounye a. Si ou pa mete l, gadmanje a ap mande w pou li nan pwochen vizit ou a.",
  "tefap_submission_pending": "Soumèt repons ou yo nan gadmanje a...",
  "cancel_edit": "Anile Edit",
  "edit": "Redije",
  "select": "Chwazi",
  "can_prepare_food": "Ka prepare manje",
  "cannot_prepare_food": "Pa ka prepare manje",
  "pantry_details_prompt_title": "{{programName}} ki nesesè",
  "pantry_details_prompt_without_visit_label": "Depo manje sa a ap itilize {{programName}} pou anrejistremàn. Ou pral gen plis kesyon pou reponn lè ou rive nan dessè a.",
  "pantry_details_prompt_visit_label": "Depo manje sa a ap itilize {{programName}} pou anrejistremàn. Sove tan nan pwochen vizit ou a pa reponn kesyon sa yo sou entènèt.",
  "state_program_attestation_cannot_complete": "Nou regrèt, men nou pa kapab konplete atestasyon ou a kounye a. Ou ka eseye ankò pita, kontakte sipò, oswa konplete sa a lè ou rive nan gadmanje a.",
  "state_program_attestation_submitted": "Mèsi pou konplete atestasyon {{programName}} ou a! Repons ou yo te soumèt avèk siksè nan gadmanje a. Sa se fen kesyon {{programName}} yo, epi nenpòt lòt mande ki vini soti nan lòt pwogram Plentiful yo.",
  "state_program_cancel_confirmation": "Eske ou sèten ou vle anile atestasyon ou an pou {{programName}}? Ou ka toujou bezwen reponn kesyon sa yo lè ou vizite gadmanje a.",
  "state_program_cancel_attestation": "Anile Atestasyon",
  "state_program_resume_attestation": "Kontinye Atestasyon",
  "tefap_no_submit": "Non, soumèt",
  "tefap_yes_retake": "Wi, repran",
  "tefap_expires": "Espire",
  "tefap_incomplete": "Enkonplè, konplete kounye a pou ekonomize tan nan pwochen vizit ou nan gadmanje a",
  "tefap_none": "Okenn",
  "tefap_benefit_programs_select": "Chwazi enskripsyon ou nan pwogram sa yo",
  "tefap_pantry_requests_info": "Pantry sa a ap mande plis enfòmasyon pou vizit kap vini ou.",
  "tefap_eligible": "Ou kalifye",
  "tefap_not_eligible": "Ou pa kalifye",
  "tefap_receive_product": "Pou resevwa pwodwi TEFAP",
  "tefap_eligible_program": "ou patisipe nan pwogram sa a",
  "tefap_eligible_programs": "ou patisipe nan pwogram sa yo",
  "tefap_not_eligible_program": "Ou pa patisipe nan okenn pwogram",
  "tefap_household_income": "revni kay ou pou",
  "tefap_info_changed": "Èske enfòmasyon sou kalifikasyon TEFAP ou a (patisipasyon nan pwogram benefis, gwosè nan kay la ak / oswa revni) dènyèman chanje?",
  "tefap_still_get_food": "Ou ka toujou resevwa manje ki pa TEFAP nan gadmanje.",
  "tefap_form_checking_here": "Pa tcheke isit la, ou ateste ki sa ki annapre yo se vre:",
  "tefap_form_checking_1": "1. Non moun k ap resevwa a, adrès ak gwosè nan kay la bay pi wo a kòrèk.",
  "tefap_form_checking_2_CO": "2. Moun k ap resevwa a abite nan Kolorado (pa gen okenn longè rezidans minimòm obligatwa).",
  "tefap_form_checking_2_NY": "2. Moun k ap resevwa a abite nan Eta New York (pa gen okenn longè minimòm nan rezidans obligatwa).",
  "tefap_form_checking_3": "3. Moun k ap resevwa a satisfè opsyon 1 ak / oswa opsyon 2 nan direktiv kalifikasyon TEFAP pi wo a.",
  "tefap_form_checking_4": "4. Sa a manje se pou konsomasyon kay moun k ap resevwa a sèlman, epi yo pa pral gen pou l vann, te fè kòmès oswa trok.",
  "tefap_form_checking_5_1": "5. Moun k ap resevwa a se okouran de dwa sivil yo jan sa dekri nan la",
  "tefap_form_checking_5_2": "Deklarasyon nondiminasyon USDA.",
  "tefap_out_of_state": "Ou ap viv nan yon eta diferan",
  "and": "ak",
  "or": "ou",
  "exceeds": "se pa anba a",
  "not_exceeds": "pa depase",
  "people": "pèp",
  "person": "moun",
  "because": "paske",
  "custom_field_first_name": "Premye non",
  "custom_field_last_name": "Siyati",
  "custom_field_contact_info": "Kontakte Info",
  "custom_field_birth_date": "Fèt",
  "custom_field_zip_code": "Kòd postal",
  "custom_field_household_size": "Gwosè houshold",
  "custom_field_food_pickup": "Reprezantan pickup",
  "custom_field_emergency_contact": "Kontak Ijans",
  "custom_field_address": "Adrese",
  "custom_field_needs_assistance": "Sikonstans espesyal (bezwen asistans)",
  "custom_field_benefits_programs": "Benefis Pwogram",
  "custom_field_tefap_income_eligibility": "Kalifikasyon Tefap Revni",
  "custom_field_relationship_status": "Sitiyasyon relasyon",
  "custom_field_ethnicity": "Etnisite",
  "custom_field_education": "Pi wo edikasyon jwenn",
  "custom_field_dietary_preferences": "Preferans dyetetik",
  "custom_field_gender": "Defans",
  "custom_field_country_of_birth": "Peyi kote ou fèt",
  "custom_field_employment": "Anplwaman",
  "custom_field_food_preparation": "Ka prepare manje",
  "custom_field_housing": "Estati Lojman",
  "search": "Chèche (Non Pantry, Kòd postal, Vil, Eta)",
  "all": "tout",
  "pantry_filter_program_type": "Kalite pwogram",
  "pantry_filter_program_type_non-food": "Ki pa Peye-Manje",
  "pantry_filter_program_type_foodpantry": "Manje Pantry (makèt gratis)",
  "pantry_filter_program_type_soupkitchen": "Soup Kitchen (repa cho gratis)",
  "pantry_filter_status": "Estati",
  "pantry_filter_status_all": "Tout",
  "pantry_filter_status_opennow": "Louvri Kounye a",
  "pantry_filter_status_opentoday": "Louvri Jodi a",
  "pantry_filter_status_openthisweek": "Louvri Semèn sa a",
  "pantry_filter_status_other": "Lòt",
  "pantry_filter_pantry_type": "Kalite gadmanje",
  "pantry_filter_pantry_type_plentifulpantry": "Plentiful Pantry",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "Verifye Patnè Pantry",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "Patnè Pantry ki pa verifye",
  "search_no_results_found": "Pa gen rezilta yo jwenn",
  "search_no_pantries_match": "Pa gen pantry ki matche \"{query}\"",
  "search_try_searching_by": "Eseye chèche pa:",
  "search_suggestion_city": "Non vil (pa egzanp, \"Brooklyn\")",
  "search_suggestion_city_accessibility": "Non vil, pa egzanp, Brooklyn",
  "search_suggestion_zipcode": "Kòd postal (pa egzanp, \"10001\")",
  "search_suggestion_zipcode_accessibility": "Kòd postal, pa egzanp, 10001",
  "search_suggestion_pantry_name": "Non pantry",
  "search_suggestion_street_address": "Adrès lari",
  "search_accessibility_no_results": "Pa gen rezilta pou {query}. Eseye chèche pa non vil, kòd postal, non pantry oswa adrès lari.",
  "search_accessibility_no_results_generic": "Pa gen rezilta yo jwenn. Eseye chèche pa non vil, kòd postal, non pantry oswa adrès lari.",
  "search_error_unable_to_display": "Pa kapab montre rezilta rechèch yo",
  "search_error_occurred": "Yon erè te fèt pandan n tap montre rezilta rechèch ou yo. Tanpri eseye chèche ankò.",
  "accessibility_phone": "Telefòn: {phone}",
  "accessibility_email": "Imel: {email}",
  "accessibility_website": "Sit wèb: {website}",
  "pantry_filter_service_type": "Kalite Sèvis",
  "pantry_filter_service_type_line": "Liy ki baze sou",
  "pantry_filter_service_type_pre-registration": "Pre-Enskripsyon",
  "pantry_filter_service_type_qr-code": "Enskripsyon QR Kòd",
  "pantry_filter_service_type_reservation": "Rezèvasyon",
  "program_type_benefit_enrollment": "Enskripsyon Benefis",
  "program_type_emergency_services": "Sèvis Ijans",
  "program_type_non_plentiful_pantry": "Ki pa Peye-Pantry",
  "program_type_other_services": "Lòt sèvis",
  "program_type_plentiful_pantry": "Plentiful Pantry",
  "program_type_shelter": "Abri",
  "program_type_soup_kitchen": "Kitchen soup",
  "service_restriction_none": "Pa gen restriksyon",
  "service_restriction_seniors": "Granmoun aje sèlman",
  "service_restriction_families_with_children": "Fanmi ki gen timoun sèlman",
  "service_restriction_new_clients": "Nouvo kliyan sèlman",
  "service_restriction_existing_clients": "Kliyan ki egziste deja sèlman",
  "filter_by_category": "Filtre pa kategori",
  "opted_out": "Li sanble ke nimewo telefòn ou opte-soti nan SMS pou nou pa ka voye ba ou kòd login ou. Tanpri patisipe tounen nan pa voye tèks mesaj START a 726879 ak Lè sa a, eseye ankò",
  "miles_away_singular": "%s mil lwen",
  "miles_away_plural": "%s mil lwen",
  "today": "jodi a",
  "address_autocomplete_placeholder": "Kòmanse tape pou wè sijesyon",
  "push_notification_permissions_denied": "Otorizasyon yo pa akòde pou notifikasyon push. Tanpri louvri paramèt sistèm ou a epi pèmèt notifikasyon pouse yo.",
  "push_notification_setup_error": "Te gen yon erè nan konfigirasyon notifikasyon pouse yo.",
  "push_notification_alternate_notifications": "W ap toujou resevwa notifikasyon via SMS oswa imel.",
  "loading_message": "Jwenn gadmanje tou pre ou",
  "location_services_no_access": "Plentiful pa sanble gen aksè a kote aparèy ou an. Tanpri aktive sèvis kote pou Plentiful nan navigatè w la oswa paramèt aparèy ou an.",
  "error_screen_header": "Oups! Gen yon bagay ki pa mache byen.",
  "error_screen_message": "Nou te rankontre yon pwoblèm inatandi. Ou ka eseye rekòmanse aplikasyon an oubyen kontakte sipò teknik la.",
  "restart_app": "Rekòmanse App",
  "email_support": "Sipò Imèl",
  "map_zoom_to_see_all": "Zoome pou wè tout kote yo",
  "program_eligible": "Ou kalifye pou {{program}}.",
  "program_ineligible": "Ou pa kalifye pou {{program}}: {{reason}}",
  "program_not_applicable": "Ou fin konplete {{program}}.",
  "program_completed": "Ou fin reponn tout kesyon {{program}} yo.",
  "program_unknown_eligibility": "Mèsi paske ou fin ranpli fòm lan. Founisè a ap detèmine si ou kalifye lè ou rive."
}
